import React from 'react'
import OrderList from './OrderList'

function Approved({status}) {
  return (
    <OrderList status={status}/>
  )
}

export default Approved